import * as React from 'react';
import PropTypes from 'prop-types';

import Icon from './Icon';

/**
 * Link
 *
 * Ref is forwarded
 */

const Link = React.forwardRef(({ url, title, icon, layout }, ref) => {
  const layoutClass = layout ? `l-${layout}` : '';
  return (
    <span ref={ref} className={`link ${layoutClass}`}>
      <a href={url} target="_blank" rel="noopener noreferrer">
        {title}
        {icon && <Icon icon={icon} />}
      </a>
    </span>
  );
});

Link.displayName = 'Link';

Link.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  layout: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default Link;
